/** Storage key that tells the drawer which tab to open on, then is cleared. */
export const MANAGE_VOLUME_ACTIVE_TAB_KEY = 'manageVolumeActiveTab';
